import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { toast } from "react-toastify";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import { Select, Form, DatePicker } from "antd";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import categoryService from "../../../../api/Category/CategoryService";
import offerService from "../../../../api/Offer/OfferService";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
const { Option } = Select;
export default class CreateOffer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categoryList: [],
      files: [],
      offer: {
        title: null,
        description: null,
        summary: null,
        category_id: null,
        rating: null,
        no_users: null,
        offer_type: null,
        map_url: null,
        mobile: null,
        link: null,
        expireDate: null,
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getCategoryList();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  getCategoryList = () => {
    let categoryList = this.state.categoryList;
    categoryService
      .getAllCategories()
      .then((res) => {
        categoryList = res.data;
        this.setState({ categoryList });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  onCreateChange = (name, value) => {
    let offer = this.state.offer;
    offer[name] = value;
    this.setState({ offer });
  };

  onDateChange = (value) => {
    let date = moment(value).format("YYYY/MM/DD");
    let offer = this.state.offer;
    offer.expireDate = date;
    this.setState({ offer });
  };

  onCreateDescriptionChange = (name, value) => {
    let offer = this.state.offer;
    offer[name] = value;
    this.setState({ offer });
  };

  onFileSelect = (e) => {
    this.setState({ files: e.target.files });
  };

  onButtonClick = () => {
    const formData = new FormData();
    for (let i = 0; i < this.state.files.length; i++) {
      formData.append("documents", this.state.files[i]);
    }
    formData.append("title", this.state.offer.title);
    formData.append("description", this.state.offer.description);
    formData.append("ar_title", this.state.offer.ar_title);
    formData.append("ar_description", this.state.offer.ar_description);
    formData.append("summary", this.state.offer.summary);
    formData.append("map_url", this.state.offer.map_url);
    formData.append("mobile", this.state.offer.mobile);
    formData.append("link", this.state.offer.link);
    formData.append("status", this.state.offer.status);
    formData.append("category_id", this.state.offer.category_id);
    this.state.offer.expireDate &&
      formData.append("expireDate", this.state.offer.expireDate);
    formData.append(
      "rating",
      this.state.offer.rating ? this.state.offer.rating : 0
    );
    formData.append(
      "no_users",
      this.state.offer.no_users ? this.state.offer.no_users : 0
    );
    formData.append("offer_type", this.state.offer.offer_type);
    offerService.addOffer(formData);
    toast.success(`Offer Created Successfuly`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.setState({
      offer: {
        title: null,
        description: null,
        summary: null,
        category_id: null,
        rating: null,
        no_users: null,
        offer_type: null,
        mobile: null,
        link: null,
        map_url: null,
        expireDate: null,
      },
      file: null,
    });
    document.getElementById("img").value = "";
    document.getElementById("title").value = "";
    document.getElementById("ar_title").value = "";
    document.getElementById("summary").value = "";
    document.getElementById("mobile").value = "";
    document.getElementById("link").value = "";
    document.getElementById("select").value = "";
  };

  render() {
    return (
      <>
        <h5 className="m-0">Create Offer</h5>
        <Row form>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="img" id="create-user">
              <label>Offer Image & Document</label>
              <FormControl
                autoFocus
                type="file"
                name="img"
                id="img"
                multiple
                onChange={this.onFileSelect.bind(this)}
              />
            </FormGroup>
            <FormGroup controlId="email" id="create-user">
              <label>Title</label>
              <FormControl
                autoFocus
                type="text"
                name="title"
                id="title"
                onChange={(e) => this.onCreateChange("title", e.target.value)}
              />
            </FormGroup>
            <FormGroup controlId="email" id="create-user">
              <label>Arabic Title</label>
              <FormControl
                autoFocus
                type="text"
                name="ar_title"
                id="ar_title"
                onChange={(e) =>
                  this.onCreateChange("ar_title", e.target.value)
                }
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group  mt-4">
            <Form layout="vertical">
              <Form.Item label="Select Category">
                <Select
                  id="select"
                  defaultValue="Select Category"
                  onChange={(value) =>
                    this.onCreateChange("category_id", value)
                  }
                >
                  {this.state.categoryList.map((cat) => {
                    return <Option value={cat.id}>{cat.name}</Option>;
                  })}
                </Select>
              </Form.Item>
            </Form>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Expire Date</label>
              <DatePicker
                style={{ width: "100%" }}
                class="form-control-select"
                id="role"
                onChange={this.onDateChange}
                allowClear={false}
                format={"DD-MM-YYYY"}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Description</label>
              {/* <FormControl
                autoFocus
                type="text"
                name="description"
                id="description"
                onChange={this.onCreateChange.bind(this)}
              /> */}
              <CKEditor
                editor={ClassicEditor}
                data="Please type here the offer description"
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  //console.log( { event, editor, data } );
                  this.onCreateDescriptionChange("description", data);
                }}
                onBlur={(event, editor) => {
                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Arabic Description</label>
              {/* <FormControl
                autoFocus
                type="text"
                name="description"
                id="description"
                onChange={this.onCreateChange.bind(this)}
              /> */}
              <CKEditor
                editor={ClassicEditor}
                data="Please type here the offer description"
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  //console.log( { event, editor, data } );
                  this.onCreateDescriptionChange("ar_description", data);
                }}
                onBlur={(event, editor) => {
                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Summary</label>
              <FormControl
                autoFocus
                type="text"
                name="summary"
                id="summary"
                onChange={(e) => this.onCreateChange("summary", e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>MAP URL</label>
              <FormControl
                autoFocus
                type="text"
                name="map_url"
                id="map_url"
                onChange={(e) => this.onCreateChange("map_url", e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Mobile</label>
              <FormControl
                autoFocus
                type="text"
                name="mobile"
                id="mobile"
                onChange={(e) => this.onCreateChange("mobile", e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Link</label>
              <FormControl
                autoFocus
                type="text"
                name="link"
                id="link"
                onChange={(e) => this.onCreateChange("link", e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group  mt-4">
            <Form layout="vertical">
              <Form.Item label="Offer Type">
                <Select
                  id="select"
                  defaultValue="Select Type"
                  onChange={(value) => this.onCreateChange("offer_type", value)}
                >
                  <Option value="internal">Internal</Option>
                  <Option value="offers">Offers</Option>
                </Select>
              </Form.Item>
            </Form>
          </Col>
          <Col md="6" className="form-group  mt-4">
            <Form layout="vertical">
              <Form.Item label="Offer Status">
                <Select
                  id="select"
                  defaultValue="Select Status"
                  onChange={(value) => this.onCreateChange("status", value)}
                >
                  <Option value="draft">Draft</Option>
                  <Option value="published">Published</Option>
                  <Option value="expired">Expired</Option>
                </Select>
              </Form.Item>
            </Form>
          </Col>
        </Row>
        <Row form>
          <Col
            md="6"
            className="form-group pt-2 align-self-center offset-6"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={() => this.onButtonClick()}
            >
              Create
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
